import { useABTestVariable } from '../../../../../hooks/useABTestVariable';
import { CustomPreference } from '../../../../../utils/api/CustomPreference';

export const useIsFilterEnabled = (): ((filterId: string) => boolean) => {
    const isSavingEnabled = useABTestVariable<boolean>(
        CustomPreference.ENABLE_SAVING_FILTERS_ON_PLP_SEARCH_PAGES as CustomPreference,
        false,
    );

    return (filterId: string): boolean => {
        if (filterId === 'saving') {
            return isSavingEnabled;
        }
        return true;
    };
};
